const PREFS_KEY = "dashboard_user_prefs";

export const getUserPrefsKey = (user) => {
  if (!user) return "guest";
  return String(user.id ?? user.username ?? user.email ?? "guest");
};

export const loadThemeModeForUser = (user) => {
  try {
    const prefs = JSON.parse(localStorage.getItem(PREFS_KEY) || "{}");
    const mode = prefs[getUserPrefsKey(user)]?.themeMode;
    return mode === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
};

export const saveThemeModeForUser = (user, mode) => {
  try {
    const prefs = JSON.parse(localStorage.getItem(PREFS_KEY) || "{}");
    const key = getUserPrefsKey(user);
    prefs[key] = { ...prefs[key], themeMode: mode };
    localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
  } catch {
    // ignore quota errors
  }
};
